import { styled } from '@mui/material';

export const StyledColumn = styled('div')(({ theme }) => ({
  gap: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column'
}));
